import _extends from "@babel/runtime/helpers/extends";
export var COMMON = {
  WHITE1: 'rgba(255, 255, 255, 1)',
  WHITE2: 'rgba(255, 255, 255, 0.48)',
  WHITE3: 'rgba(255, 255, 255, 0.28)',
  WHITE4: 'rgba(255, 255, 255, 0.16)',
  WHITE5: 'rgba(255, 255, 255, 0.08)'
};
export var LIGHT = {
  LEVEL1: 'rgba(23, 26, 29, 0.94)',
  LEVEL2: 'rgba(23, 26, 29, 0.6)',
  LEVEL3: 'rgba(23, 26, 29, 0.4)',
  LEVEL4: 'rgba(23, 26, 29, 0.24)',
  LEVEL5: 'rgba(23, 26, 29, 0.04)',
  BG_DEFAULT: 'rgba(255, 255, 255, 1)',
  BG_LIGHT: 'rgba(250, 251, 251, 1)',
  BG_HEAVY: '#F5F6F7',
  FG_LIGHT: 'rgba(255, 255, 255, 1)',
  FG_HEAVY: 'rgba(255, 255, 255, 1)',
  FG_TOAST: 'rgba(70, 72, 74, 1)',
  FG_FROSTING: 'rgba(255, 255, 255, 0.8)',
  FG_HIGHLIGHT: 'rgba(245, 246, 247, 1)',
  OVERLAY_LIGHT: 'rgba(23, 26, 29, 0.06)',
  OVERLAY_HEAVY: 'rgba(23, 26, 29, 0.1)',
  OVERLAY_HIGHLIGHT: 'rgba(63, 133, 255, 0.1)',
  OVERLAY_MASK: 'rgba(23, 26, 29, 0.18)',
  LINE_LIGHT: 'rgba(23, 26, 29, 0.08)',
  LINE_HEAVY: 'rgba(23, 26, 29, 0.14)',
  BRAND1: 'rgba(63, 133, 255, 1)',
  BRAND2: 'rgba(58, 123, 235, 1)',
  BRAND3: 'rgba(53, 112, 214, 1)',
  BRAND4: 'rgba(63, 133, 255, 0.48)',
  RED1: 'rgba(238, 93, 80, 1)',
  RED2: 'rgba(219, 86, 74, 1)',
  RED3: 'rgba(200, 78, 67, 1)',
  RED4: 'rgba(238, 93, 80, 0.48)',
  RED5: 'rgba(238, 93, 80, 0.12)',
  YELLOW0: 'rgba(240, 196, 23, 1)',
  YELLOW1: 'rgba(255, 206, 32, 1)',
  YELLOW2: 'rgba(255, 206, 32, 0.48)',
  YELLOW3: 'rgba(255, 206, 32, 0.12)',
  GREEN1: 'rgba(5, 205, 153, 1)',
  GREEN2: 'rgba(5, 205, 153, 0.48)',
  GREEN3: 'rgba(5, 205, 153, 0.12)',
  BLUE1: 'rgba(63, 133, 255, 1)',
  BLUE2: 'rgba(63, 133, 255, 0.48)',
  BLUE3: 'rgba(63, 133, 255, 0.12)',
  // 色板

  SPEARMINT1: 'rgba(189, 226, 90, 1)',
  SPEARMINT2: 'rgba(179, 214, 20, 1)',
  SPEARMINT3: 'rgba(162, 226, 115, 1)',
  SPEARMINT4: 'rgba(189, 226, 90, 0.22)',
  SEA1: 'rgba(73, 212, 240, 1)',
  SEA2: 'rgba(45, 198, 249, 1)',
  SEA3: 'rgba(57, 201, 241, 0.6)',
  SEA4: 'rgba(134, 223, 247, 0.24)',
  CERULEAN1: 'rgba(141, 200, 250, 1)',
  CERULEAN2: 'rgba(111, 151, 222, 1)',
  CERULEAN3: 'rgba(135, 185, 231, 0.6)',
  CERULEAN4: 'rgba(135, 185, 231, 0.18)',
  PURPLE1: 'rgba(113, 101, 242, 1)',
  PURPLE2: 'rgba(116, 89, 238, 1)',
  PURPLE3: 'rgba(110, 116, 253, 0.6)',
  PURPLE4: 'rgba(110, 116, 253, 0.16)',
  ORANGE1: 'rgba(250, 134, 79, 1)',
  ORANGE2: 'rgba(251, 101, 20, 1)',
  ORANGE3: 'rgba(255, 137, 27, 0.6)',
  ORANGE4: 'rgba(255, 137, 27, 0.18)'
};
export var DARK = {
  LEVEL1: 'rgba(255, 255, 255, 0.8)',
  LEVEL2: 'rgba(255, 255, 255, 0.5)',
  LEVEL3: 'rgba(255, 255, 255, 0.4)',
  LEVEL4: 'rgba(255, 255, 255, 0.2)',
  LEVEL5: 'rgba(255, 255, 255, 0.03)',
  BG_DEFAULT: '#111213',
  BG_LIGHT: '#18191B',
  BG_HEAVY: '#141718',
  FG_LIGHT: 'rgba(35, 36, 37, 1)',
  FG_HEAVY: 'rgba(28, 29, 31, 1)',
  FG_TOAST: 'rgba(54, 55, 56, 1)',
  FG_FROSTING: 'rgba(28, 29, 31, 0.9)',
  FG_HIGHLIGHT: 'rgba(32, 33, 36, 1)',
  OVERLAY_LIGHT: 'rgba(255, 255, 255, 0.08)',
  OVERLAY_HEAVY: 'rgba(255, 255, 255, 0.16)',
  OVERLAY_HIGHLIGHT: 'rgba(86, 121, 182, 0.2)',
  OVERLAY_MASK: 'rgba(0, 0, 0, 0.36)',
  LINE_LIGHT: 'rgba(126, 134, 142, 0.16)',
  LINE_HEAVY: 'rgba(126, 134, 142, 0.24)',
  BRAND1: '#3978E5',
  BRAND2: '#346DD1',
  BRAND3: '#2F63BD',
  BRAND4: 'rgba(57, 120, 229, 0.48)',
  RED1: '#D45347',
  RED2: '#C24C41',
  RED3: '#AD443A',
  RED4: 'rgba(212, 83, 71, 0.48)',
  RED5: 'rgba(212, 83, 71, 0.24)',
  YELLOW0: '#DBB316',
  YELLOW1: '#EBBE1D',
  YELLOW2: 'rgba(235, 190, 29, 0.48)',
  YELLOW3: 'rgba(235, 190, 29, 0.24)',
  GREEN1: '#04B285',
  GREEN2: 'rgba(4, 178, 133, 0.48)',
  GREEN3: 'rgba(4, 178, 133, 0.24)',
  BLUE1: '#3978E5',
  BLUE2: 'rgba(57, 120, 229, 0.48)',
  BLUE3: 'rgba(57, 120, 229, 0.24)',
  // 色板

  SPEARMINT1: '#A8C950',
  SPEARMINT2: '#9EBD12',
  SPEARMINT3: 'rgba(144, 201, 103, 0.6)',
  SPEARMINT4: 'rgba(168, 201, 80, 0.24)',
  SEA1: '#41BDD6',
  SEA2: '#29B2E0',
  SEA3: 'rgba(51, 181, 217, 0.6)',
  SEA4: 'rgba(120, 200, 222, 0.24)',
  CERULEAN1: '#7FB4E0',
  CERULEAN2: '#6286C4',
  CERULEAN3: 'rgba(121, 165, 207, 0.6)',
  CERULEAN4: 'rgba(121, 165, 207, 0.24)',
  PURPLE1: '#655AD9',
  PURPLE2: '#674FD4',
  PURPLE3: 'rgba(99, 104, 227, 0.6)',
  PURPLE4: 'rgba(99, 104, 227, 0.24)',
  ORANGE1: '#E07847',
  ORANGE2: '#E05A12',
  ORANGE3: 'rgba(229, 123, 24, 0.6)',
  ORANGE4: 'rgba(229, 123, 24, 0.24)'
};
export var COLORS_CLASSIC_LIGHT = _extends({}, LIGHT, COMMON);
export var COLORS_CLASSIC_DARK = _extends({}, DARK, COMMON);